<template>
  <hypto-popup title="Resend Webhooks Confirmation">
    <template v-slot:body>
      <p>Are you sure you want to <b>Resend Webhooks</b> for these <b>{{webhookOptions.total}}</b> {{pluralize(webhookOptions.type || 'transaction', webhookOptions.total)}}?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="resendWebhooks">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import { pluralize } from '@/utils/helpers'

export default {
  name: 'ResendWebhooksConfirmation',
  components: { HyptoPopup },
  props: {
    webhookOptions: Object
  },
  methods: {
    pluralize,
    resendWebhooks () {
      this.$emit('resendWebhooks')
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
  }

  .mobile {
    p {
      text-align: left;
    }
  }
</style>
